<template>
  <div class="box">
    <div v-if="hasNav">
      <nav class="navbar" role="navigation" aria-label="main navigation">
        <div class="navbar-menu">
          <div class="navbar-start">
            <div class="navbar-item has-dropdown is-hoverable">
              <a class="navbar-link">New</a>
              <div class="navbar-dropdown">
                <!-- <a class="navbar-item">File</a> -->
                <router-link
                  class="navbar-item"
                  :to="{ path: 'e-studio', query: { type: type } }"
                >File</router-link>
                <!-- <a class="navbar-item">Folder</a> -->
              </div>
            </div>
            <!-- <a class="navbar-item">Documentation</a> -->
          </div>
        </div>
      </nav>
      <hr />
    </div>
    <h2 class="subtitle is-pulled-left" v-if="title">{{ title }}</h2>
    <table class="table is-fullwidth is-striped is-hoverable">
      <thead>
        <tr>
          <!-- <th>Folder</th> -->
          <th>File</th>
          <th>Date Modified</th>
        </tr>
      </thead>
      <tbody>
        <!-- <tr>
          <td>
            <div class="level">
              <span class="level-item icon is-medium">
                <img src="../../assets/img/icons/draft-icon.svg">
              </span>
              FOLDER NAME
            </div>
            </td>
          </td>
          <td>&nbsp;</td>
          <td>2019-09-28 00:12:11</td>
        </tr>-->
        <tr v-for="file in files" :key="file.id">
          <td>
            <router-link :to="'/e-studio/'+file.id">
              <span class="icon is-small">
                <img src="../../assets/img/icons/file.svg" />
              </span>
              {{ file.name }}
            </router-link>
          </td>
          <td>{{ file.updated_at.date.substring(0,19) }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { ACCESS_TOKEN, API_URL } from "../../Variables";

export default {
  name: "FileBrowser",
  components: {},
  props: {
    hasNav: {
      type: Boolean,
      required: false,
      default: true
    },
    files: {
      type: Array,
      required: true
    },
    type: {
      type: String,
      required: false,
      default: "journal"
    },
    title: {
      type: String,
      required: false,
      default: ""
    }
  },
  computed: {
    ...mapState({})
  },
  data() {
    return {
      access_token: ACCESS_TOKEN,
      isLoading: false
    };
  },
  mounted() {},
  methods: {}
};
</script>

<style lang="scss" >
</style>